<app-vw-kopf
  ausrichtung="ende"
  [titel]="'verwaltung.bereich.benutzer.titel' | translate"
  [untertitel]="'verwaltung.bereich.benutzer.untertitel' | translate"
>
  <div class="vw-benutzer__kopf-rechts">
    <div class="vw-benutzer__kennzahlen">
      @for (k of statusWerte; track k) {
        <div class="vw-benutzer__kennzahl" [attr.data-testid]="'vw-benutzer-kennzahl-' + k">
          <div class="vw-benutzer__kennzahl-label">{{ 'verwaltung.benutzer.kennzahl.' + k | translate }}</div>
          <div class="vw-benutzer__kennzahl-wert vw-benutzer__kennzahl-wert--{{ k }}" data-wert>
            {{ kennzahlWert(k) }}
          </div>
        </div>
      }
    </div>
    <a class="vw-benutzer__einladen" routerLink="/settings/benutzer/neu" data-testid="vw-person-einladen">
      <span class="vw-benutzer__einladen-icon" aria-hidden="true">＋</span>
      {{ 'verwaltung.benutzer.einladen' | translate }}
    </a>
  </div>
</app-vw-kopf>

<div class="vw-benutzer__werkzeuge">
  <div class="vw-benutzer__suche">
    <svg class="vw-benutzer__lupe" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8" />
      <path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </svg>
    <input
      #suchfeld
      type="text"
      class="vw-benutzer__suchfeld"
      data-testid="vw-benutzer-suche"
      [attr.maxlength]="fieldLengths.NAME_MAX"
      [placeholder]="'verwaltung.benutzer.suche' | translate"
      [attr.aria-label]="'verwaltung.benutzer.suche' | translate"
      [value]="suche()"
      (input)="suche.set(suchfeld.value)"
    />
  </div>
  <select
    #filterfeld
    class="vw-benutzer__filter"
    data-testid="vw-benutzer-status-filter"
    [class.vw-benutzer__filter--aktiv]="statusFilter() !== 'alle'"
    [attr.aria-label]="'verwaltung.benutzer.filter.label' | translate"
    (change)="statusFilterSetzen(filterfeld.value)"
  >
    <option value="alle" [selected]="statusFilter() === 'alle'">
      {{ 'verwaltung.benutzer.filter.alle' | translate }}
    </option>
    @for (s of statusWerte; track s) {
      <option [value]="s" [selected]="statusFilter() === s">{{ 'verwaltung.benutzer.status.' + s | translate }}</option>
    }
  </select>
  @if (filterAktiv()) {
    <button
      type="button"
      class="vw-benutzer__zuruecksetzen"
      data-testid="vw-filter-zuruecksetzen"
      (click)="filterZuruecksetzen()"
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      {{ 'verwaltung.benutzer.zuruecksetzen' | translate }}
    </button>
  }
</div>

<div class="vw-benutzer__karte">
  <div class="vw-benutzer__tabelle" role="table" [attr.aria-label]="'verwaltung.benutzer.tabelle' | translate">
    <div class="vw-benutzer__raster vw-benutzer__kopfzeile" role="row">
      <span role="columnheader">{{ 'verwaltung.benutzer.spalte.person' | translate }}</span>
      <span role="columnheader">{{ 'verwaltung.benutzer.spalte.rolle' | translate }}</span>
      <span role="columnheader">{{ 'verwaltung.benutzer.spalte.status' | translate }}</span>
      <span role="columnheader">
        <span class="sr-only">{{ 'verwaltung.benutzer.spalte.aktionen' | translate }}</span>
      </span>
    </div>
    @for (z of zeilen(); track z.id) {
      <div
        class="vw-benutzer__raster vw-benutzer__zeile"
        [class.vw-benutzer__zeile--deaktiviert]="z.status === 'deaktiviert'"
        role="row"
        data-testid="vw-benutzer-zeile"
        [attr.data-zeile-id]="z.id"
      >
        <div class="vw-benutzer__person" role="cell">
          <span class="vw-benutzer__avatar" aria-hidden="true"><app-avatar [name]="z.avatar" [size]="38" /></span>
          <div class="vw-benutzer__person-text">
            <div class="vw-benutzer__name" data-testid="vw-benutzer-name">
              {{ z.name }}
              @if (z.eigene) {
                <span>{{ 'verwaltung.benutzer.du' | translate }}</span>
              }
            </div>
            <div class="vw-benutzer__mail" [attr.title]="z.email">{{ z.email }}</div>
          </div>
        </div>
        <span class="vw-benutzer__rolle" role="cell" data-testid="vw-benutzer-rolle">{{ z.rolle | translate }}</span>
        <span role="cell">
          <span class="vw-benutzer__pill vw-benutzer__pill--{{ z.status }}" data-testid="vw-benutzer-status">
            <span class="vw-benutzer__punkt" aria-hidden="true"></span>
            {{ 'verwaltung.benutzer.status.' + z.status | translate }}
          </span>
        </span>
        <div class="vw-benutzer__aktionen" role="cell">
          <button
            type="button"
            class="vw-benutzer__knopf"
            data-aktion="rollen"
            data-testid="vw-rollen"
            [attr.aria-disabled]="z.rollenSperre ? 'true' : null"
            [attr.aria-label]="'verwaltung.benutzer.aria.rollen' | translate: { name: z.name }"
            [matTooltip]="z.rollenSperre ? ('verwaltung.benutzer.rollenGesperrt.' + z.rollenSperre | translate) : ''"
            [matTooltipDisabled]="!z.rollenSperre"
            (click)="rollenOeffnen(z)"
          >
            {{ 'verwaltung.benutzer.aktion.rollen' | translate }}
          </button>
          @if (z.aktionen.deaktivieren) {
            <button
              type="button"
              class="vw-benutzer__knopf vw-benutzer__knopf--gefahr"
              data-aktion="deaktivieren"
              data-testid="vw-deaktivieren"
              [attr.aria-busy]="laeuft().has(z.id) || null"
              [attr.aria-label]="'verwaltung.benutzer.aria.deaktivieren' | translate: { name: z.name }"
              (click)="deaktivierenFragen(z)"
            >
              {{ 'verwaltung.benutzer.aktion.deaktivieren' | translate }}
            </button>
          }
          @if (z.aktionen.aktivieren) {
            <button
              type="button"
              class="vw-benutzer__knopf"
              [attr.aria-busy]="laeuft().has(z.id) || null"
              [attr.aria-label]="'verwaltung.benutzer.aria.aktivieren' | translate: { name: z.name }"
              data-aktion="aktivieren"
              data-testid="vw-aktivieren"
              (click)="aktivieren(z)"
            >
              {{ 'verwaltung.benutzer.aktion.aktivieren' | translate }}
            </button>
          }
          @if (z.aktionen.erneutSenden) {
            @if (gesendet().has(z.id)) {
              <button
                type="button"
                class="vw-benutzer__knopf"
                disabled
                [attr.aria-label]="'verwaltung.benutzer.aria.gesendet' | translate: { name: z.name }"
              >
                {{ 'verwaltung.benutzer.aktion.gesendet' | translate }}
              </button>
            } @else {
              <button
                type="button"
                class="vw-benutzer__knopf"
                data-testid="vw-erneut-senden"
                [disabled]="ersetztOhneZustellung(z.id)"
                [attr.aria-busy]="laeuft().has(z.id) || null"
                [attr.aria-label]="'verwaltung.benutzer.aria.erneutSenden' | translate: { name: z.name }"
                (click)="erneutSenden(z)"
              >
                {{ 'verwaltung.benutzer.aktion.erneutSenden' | translate }}
              </button>
            }
          }
        </div>
      </div>
    }
  </div>

  @switch (store.personenZustand()) {
    @case ('laedt') {
      <div class="vw-benutzer__hinweis" role="status" data-testid="vw-benutzer-laden">
        {{ 'verwaltung.benutzer.laden' | translate }}
      </div>
    }
    @case ('fehler') {
      <div class="vw-benutzer__hinweis" role="alert" data-testid="vw-benutzer-fehler">
        <p class="vw-benutzer__fehlertext">{{ 'verwaltung.benutzer.fehler' | translate }}</p>
        <button
          type="button"
          class="vw-benutzer__knopf"
          data-testid="vw-benutzer-erneut"
          (click)="store.personenAktualisieren()"
        >
          {{ 'verwaltung.benutzer.erneut' | translate }}
        </button>
      </div>
    }
    @default {
      @if (zeilen().length === 0) {
        <div class="vw-benutzer__hinweis" data-testid="vw-benutzer-leer">
          {{ 'verwaltung.benutzer.leer' | translate }}
        </div>
      }
    }
  }
</div>

<app-confirm-dialog
  icon="person_off"
  [visible]="frage() !== null"
  [title]="'verwaltung.benutzer.frage.titel' | translate"
  [message]="'verwaltung.benutzer.frage.text' | translate: { name: frage()?.name ?? '' }"
  [confirmLabel]="'verwaltung.benutzer.frage.bestaetigen' | translate"
  [cancelLabel]="'verwaltung.benutzer.frage.abbrechen' | translate"
  confirmTestId="vw-deaktivieren-bestaetigen"
  [busy]="frageLaeuft()"
  (confirmed)="deaktivierenBestaetigen()"
  (cancelled)="frage.set(null)"
/>
